export const QUERY_KEY_TRACKABLE_OBJECTS_SINGLE_VOYAGES = 'trackable_objects_single_voyage'
